import { SendingSchedule } from '../../shared/types/SendingSchedule'
import { SendingScheduleEntity } from '../../domain/entities/SendingSchedule'
import { AdvertEntity } from '../../domain/entities/Advert'
import { AdvertTitle } from '../../domain/value-objects/AdvertTitle'
import { ChannelAPIModel, mapApiToEntity as mapChannelApiToEntity } from './channels.mapper'
import { TelegramAccountEntity } from '../../domain/entities/TelegramAccount'

export type SendingScheduleAPIModel = SendingSchedule

export const mapApiToEntity = (api: SendingScheduleAPIModel): SendingScheduleEntity => {
  const adverts = (api.adverts || []).map(a => AdvertEntity.create({
    uuid: a.uuid,
    id: a.id,
    title: AdvertTitle.create(a.title),
    description: a.description,
    accountId: a.accountId,
    createdAt: new Date(a.createdAt),
    updatedAt: new Date(a.updatedAt),
    attachments: (a.attachments || []).map(att => ({ uuid: (att as any).uuid, url: att.url, type: att.type as any, position: att.position }))
  }))
  const channel = mapChannelApiToEntity(api.channel as unknown as ChannelAPIModel)
  const tg = TelegramAccountEntity.create({
    id: api.telegramAccount.id,
    uuid: api.telegramAccount.uuid,
    phone: api.telegramAccount.phone,
    accountID: api.telegramAccount.accountID,
    status: api.telegramAccount.status as any
  })
  return SendingScheduleEntity.create({
    uuid: api.uuid,
    adverts,
    channel,
    telegramAccount: tg,
    accountId: api.accountId,
    defaultSendingIntervalSeconds: api.defaultSendingIntervalSeconds,
    isActive: api.isActive,
    createdAt: new Date(api.createdAt),
    updatedAt: api.updatedAt ? new Date(api.updatedAt) : undefined,
  })
}
